import React from 'react';
import PropTypes from "prop-types";
import { Modal } from 'react-bootstrap';
import Accordion from '@separate/components/Accordion';
import Button from '@separate/components/Button';
import { useTranslation } from '@separate/hooks/translation';
import { CloseCircle } from '@separate/icons';
import styles from './poderSaludCancellationPolicy.module.scss';

const PoderSaludCancellationPolicy = (props) => {
  const { staticModal, redirectToBenefitsHub } = props;
  const { t } = useTranslation();
  const [show, setShow] = React.useState(staticModal);

  const onShow = () => {
    setShow(true);
  };

  const onHide = () => {
    if(redirectToBenefitsHub) redirectToBenefitsHub();
    setShow(false);
  };

  const faqItems = [
    ...t('benefits.cancellation_policy.faq.items', { returnObjects: true })
  ];

  return (
    <div className={styles.cancellationPolicy}>
      <Button className={styles.button} onClick={onShow}>
        {t('benefits.cancellation_policy.title')}
      </Button>

      <Modal
        fullscreen={true}
        show={show}
        onHide={onHide}
        className={styles.cancellationPolicyModal}
      >

        <Modal.Header className={styles.header}>
          <Modal.Title className={styles.title}>
            {t('benefits.cancellation_policy.title')}
          </Modal.Title>

          <CloseCircle
            className={styles.closeButton}
            onClick={onHide}
            role='button'
          />

        </Modal.Header>

        <Modal.Body className={styles.accordion}>
          <Accordion
            items={faqItems}
            toggleClassName={styles.accordionToggle}
            alwaysOpen={false}
            defaultActiveKey={0}
          />
        </Modal.Body>

        <Modal.Footer className={styles.footer}>
          <p>{t('benefits.cancellation_policy.this_is_not_insurance')}</p>
        </Modal.Footer>

      </Modal>
    </div>
  );
};

PoderSaludCancellationPolicy.propTypes = {
  staticModal: PropTypes.bool,
  redirectToBenefitsHub: PropTypes.func
};

export default PoderSaludCancellationPolicy;
